import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBookmark, faShip } from '@fortawesome/pro-regular-svg-icons'
import { useTranslations } from 'next-intl'
import { faComment, faShare } from '@fortawesome/pro-solid-svg-icons'

import VesselBookmarkButton from './VesselBookmarkButton'
import { getVesselImageUrl } from '../utils'

import type { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'
import { Link } from '@/i18n/navigation'

import './VesselDetailHeader.scss'

export type TPropsVesselDetailHeader = {
  vessel: TVesselJourneyResponse
}

function VesselDetailHeader({ vessel }: TPropsVesselDetailHeader) {
  const t = useTranslations()

  return (
    <div className="vessel--extra-details-header">
      <div className="image">
        {/* eslint-disable-next-line @next/next/no-img-element */}
        <img src={getVesselImageUrl(vessel)} alt="Vessel ship image" />
      </div>
      <div className="vessel-info">
        <div className="vessel-name-container">
          <div className="vessel-name">
            <Link href={`/vessels/${vessel.ship.imo}`}>
              <h1 className="h2">
                {vessel.ship.name} <span className="h3">{vessel.ship.imo}</span>
              </h1>
            </Link>
          </div>
          <VesselBookmarkButton vessel={vessel} />
        </div>
        <h2 className="hidden-description">
          {t('metadata.vessel.description', {
            vesselName: vessel.ship.name || t('common.unknownVessel'),
            category: vessel.ship.category,
            country: vessel.ship.country.name || t('common.unknown'),
            departurePort: vessel.departure?.port?.name || t('common.unknown'),
            arrivalPort: vessel.arrival?.port?.name || t('common.unknown'),
            loa: vessel.ship.lengthOverall,
            gt: vessel.ship.grossTonnage || 0,
            dwt: vessel.ship.deadWeightTonnage || 0,
            imo: vessel.ship.imo
          })}
        </h2>
        <div className="vessel-category">
          <FontAwesomeIcon icon={faShip} />
          {vessel.ship.category}
        </div>
        <div className="social-metrics">
          <div className="social-metrics">
            {vessel.stats?.notesAmount && vessel.stats.notesAmount > 1 ? (
              <div className="social-metric-item">
                <FontAwesomeIcon icon={faComment} />
                <span>{vessel.stats?.notesAmount}</span>
              </div>
            ) : null}
            {vessel.stats?.subscriptionAmount && vessel.stats.subscriptionAmount > 1 ? (
              <div className="social-metric-item">
                <FontAwesomeIcon icon={faBookmark} />
                <span>{vessel.stats?.subscriptionAmount}</span>
              </div>
            ) : null}
            {vessel.stats?.sharingAmount && vessel.stats.sharingAmount > 1 ? (
              <div className="social-metric-item">
                <FontAwesomeIcon icon={faShare} />
                <span>{vessel.stats.sharingAmount}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  )
}

export default VesselDetailHeader
